export default function booleanToWord(value: boolean): string {
  return value ? 'Yes' : 'No'
}
